export default {
    program: {
        id: null,
        tittle: null,
        active: null
    },
    sections: [],
    section: {
        id: null,
        code: null,
        tittle: null,
        active: null,
        description: null,
        slq_program_accident_id: null,
        sub_sections: []
    },
    sub_section: {
        id: null,
        code: null,
        tittle: null,
        active: null,
        description: null,
        slq_section_accident_id: null,
        tables: []
    },
    table:{
        id: null,
        code: null,
        name: null,
        active: null,
        columns:[]
    }
};
